import { Injectable } from '@angular/core';
import { loadMessages, locale } from 'devextreme/localization';
import DateBox from 'devextreme/ui/date_box';
import DropDownBox from 'devextreme/ui/drop_down_box';
import NumberBox from 'devextreme/ui/number_box';
import Scrollable from 'devextreme/ui/scroll_view/ui.scrollable';
import SelectBox from 'devextreme/ui/select_box';
import TextArea from 'devextreme/ui/text_area';
import TextBox from 'devextreme/ui/text_box';

@Injectable({
  providedIn: 'root',
})
export class DevExtremeConfigService {
  private initialized = false;

  initialize(currentLocale = 'en-CA'): void {
    if (this.initialized) {
      locale(currentLocale);
      return;
    }

    // Load DevExtreme localization messages
    loadMessages({
      'en-CA': {
        Loading: 'Loading...',
        Select: 'Select...',
        Cancel: 'Cancel',
        Search: 'Search',
        'dxList-selectAll': 'Select All',
        'dxDataGrid-noDataText': 'No Data',
        'dxCollectionWidget-noDataText': 'No Data to Display',
        'dxDataGrid-filterRowShowAllText': '(All)',
        'dxDataGrid-trueText': 'Yes',
        'dxDataGrid-falseText': 'No',
        'dxDataGrid-headerFilterEmptyValue': '(Blanks)',
        'dxDataGrid-headerFilterOK': 'OK',
        'dxDataGrid-headerFilterCancel': 'Cancel',
        'dxDataGrid-filterRowOperationStartsWith': 'Starts with',
        'dxDataGrid-filterRowOperationContains': 'Contains',
        'dxDataGrid-filterRowOperationNotContains': 'Does not contain',
        'dxDataGrid-filterRowOperationEndsWith': 'Ends with',
        'dxDataGrid-filterRowOperationEquals': 'Equals',
        'dxDataGrid-filterRowOperationNotEquals': 'Does not equal',
        'dxDataGrid-filterRowResetOperationText': 'Reset',
        'dxDataGrid-filterRowOperationLess': 'Less than',
        'dxDataGrid-filterRowOperationLessOrEquals': 'Less than or equal to',
        'dxDataGrid-filterRowOperationGreater': 'Greater than',
        'dxDataGrid-filterRowOperationGreaterOrEquals': 'Greater than or equal to',
        'dxDataGrid-filterRowOperationBetween': 'Between',
        'dxDataGrid-filterRowOperationBetweenStartText': 'Start',
        'dxDataGrid-filterRowOperationBetweenEndText': 'End',
        'dxDataGrid-filterBuilderPopupTitle': 'Filter Builder',
        'dxDataGrid-filterPanelCreateFilter': 'Create Filter',
        'dxDataGrid-filterPanelClearFilter': 'Clear',
        'dxDataGrid-filterPanelFilterEnabledHint': 'Enable the filter',
        'dxFilterBuilder-and': 'And',
        'dxFilterBuilder-or': 'Or',
        'dxFilterBuilder-notAnd': 'Not And',
        'dxFilterBuilder-notOr': 'Not Or',
        'dxFilterBuilder-addCondition': 'Add Condition',
        'dxFilterBuilder-addGroup': 'Add Group',
        'dxFilterBuilder-enterValueText': '<enter a value>',
        'dxFilterBuilder-filterOperationEquals': 'Equals',
        'dxFilterBuilder-filterOperationNotEquals': 'Does not equal',
        'dxFilterBuilder-filterOperationLess': 'Is less than',
        'dxFilterBuilder-filterOperationLessOrEquals': 'Is less than or equal to',
        'dxFilterBuilder-filterOperationGreater': 'Is greater than',
        'dxFilterBuilder-filterOperationGreaterOrEquals': 'Is greater than or equal to',
        'dxFilterBuilder-filterOperationStartsWith': 'Starts with',
        'dxFilterBuilder-filterOperationContains': 'Contains',
        'dxFilterBuilder-filterOperationNotContains': 'Does not contain',
        'dxFilterBuilder-filterOperationEndsWith': 'Ends with',
        'dxFilterBuilder-filterOperationIsBlank': 'Is blank',
        'dxFilterBuilder-filterOperationIsNotBlank': 'Is not blank',
        'dxFilterBuilder-filterOperationBetween': 'Is between',
        'dxFilterBuilder-filterOperationAnyOf': 'Is any of',
        'dxFilterBuilder-filterOperationNoneOf': 'Is none of',
        'dxPager-infoText': 'Page {0} of {1} ({2} items)',
        'dxPager-pagesCountText': 'of',
        'dxPager-pageSizesAllText': 'All',
      },
      'fr-CA': {
        Loading: 'Chargement...',
        Select: 'Sélectionner...',
        Cancel: 'Annuler',
        Search: 'Recherche',
        'dxList-selectAll': 'Sélectionner tout',
        'dxCollectionWidget-noDataText': 'Aucune donnée à afficher',
        'dxDataGrid-noDataText': 'Pas de données',
        'dxDataGrid-filterRowShowAllText': '(Tout)',
        'dxDataGrid-trueText': 'Oui',
        'dxDataGrid-falseText': 'Non',
        'dxDataGrid-headerFilterEmptyValue': '(aucune valeur)',
        'dxDataGrid-headerFilterOK': 'OK',
        'dxDataGrid-headerFilterCancel': 'Annuler',
        'dxDataGrid-filterRowOperationStartsWith': 'Commence avec',
        'dxDataGrid-filterRowOperationContains': 'Contient',
        'dxDataGrid-filterRowOperationNotContains': 'Ne contient pas',
        'dxDataGrid-filterRowOperationEndsWith': 'Se termine par',
        'dxDataGrid-filterRowOperationEquals': 'Est égal',
        'dxDataGrid-filterRowOperationNotEquals': "N'est pas égal",
        'dxDataGrid-filterRowResetOperationText': 'Réinitialiser',
        'dxDataGrid-filterRowOperationLess': 'Moins que',
        'dxDataGrid-filterRowOperationLessOrEquals': 'Moins que ou égal à',
        'dxDataGrid-filterRowOperationGreater': 'Plus grand que',
        'dxDataGrid-filterRowOperationGreaterOrEquals': 'Plus grand que ou égal à',
        'dxDataGrid-filterRowOperationBetween': 'Entre',
        'dxDataGrid-filterRowOperationBetweenStartText': 'Début',
        'dxDataGrid-filterRowOperationBetweenEndText': 'Fin',
        'dxDataGrid-filterBuilderPopupTitle': 'Création de filtre',
        'dxDataGrid-filterPanelCreateFilter': 'Créer un filtre',
        'dxDataGrid-filterPanelClearFilter': 'Supprimer',
        'dxDataGrid-filterPanelFilterEnabledHint': 'Activer le filtre',
        'dxFilterBuilder-and': 'Et',
        'dxFilterBuilder-or': 'Ou',
        'dxFilterBuilder-notAnd': 'Non Et',
        'dxFilterBuilder-notOr': 'Non Ou',
        'dxFilterBuilder-addCondition': 'Ajouter une condition',
        'dxFilterBuilder-addGroup': 'Ajouter un groupe',
        'dxFilterBuilder-enterValueText': '<entrer une valeur>',
        'dxFilterBuilder-filterOperationEquals': 'Est égal à',
        'dxFilterBuilder-filterOperationNotEquals': 'Est différent de',
        'dxFilterBuilder-filterOperationLess': 'Est plus petit que',
        'dxFilterBuilder-filterOperationLessOrEquals': 'Est plus petit ou égal à',
        'dxFilterBuilder-filterOperationGreater': 'Est plus grand que',
        'dxFilterBuilder-filterOperationGreaterOrEquals': 'Est plus grand ou égal à',
        'dxFilterBuilder-filterOperationStartsWith': 'Commence par',
        'dxFilterBuilder-filterOperationContains': 'Contient',
        'dxFilterBuilder-filterOperationNotContains': 'Ne contient pas',
        'dxFilterBuilder-filterOperationEndsWith': 'Finit par',
        'dxFilterBuilder-filterOperationIsBlank': 'Est vide',
        'dxFilterBuilder-filterOperationIsNotBlank': "N'est pas vide",
        'dxFilterBuilder-filterOperationBetween': 'Entre',
        'dxFilterBuilder-filterOperationAnyOf': 'Est parmi',
        'dxFilterBuilder-filterOperationNoneOf': "N'est pas parmi",
        'dxPager-infoText': 'Page {0} de {1} ({2} articles)',
        'dxPager-pagesCountText': 'sur',
        'dxPager-pageSizesAllText': 'Tous',
      },
    });

    locale(currentLocale);
    this.configureDefaultOptions();
    this.initialized = true;
  }

  setLocale(localeCode: string): void {
    locale(localeCode);
  }

  private configureDefaultOptions(): void {
    NumberBox.defaultOptions({ options: { stylingMode: 'outlined' } });
    TextArea.defaultOptions({ options: { stylingMode: 'outlined' } });
    DateBox.defaultOptions({ options: { stylingMode: 'outlined', calendarOptions: { firstDayOfWeek: 0 } } });
    SelectBox.defaultOptions({ options: { stylingMode: 'outlined' } });
    DropDownBox.defaultOptions({ options: { stylingMode: 'outlined' } });
    TextBox.defaultOptions({ options: { stylingMode: 'outlined' } });
    Scrollable.defaultOptions({ options: { showScrollbar: 'onHover' } });
  }
}
